<template>
  <el-row class="headBox">
    <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
      <div class="headBox_title">雅安市名山区国有资产投资经营有限责任公司</div>
    </el-col>
  </el-row>

  <el-row class="menu-row">
    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
      <div class="menu-box" ref="menuRef" :class="{ isfixed: isFixed == 1, noFixed: isFixed == 2 }">
        <!-- 移动端汉堡菜单按钮 -->
        <div class="mobile-menu-btn" @click="toggleMobileMenu">
          <el-icon :size="24">
            <Menu />
          </el-icon>
        </div>
        
        <!-- 桌面端菜单 -->
        <el-menu
          class="desktop-menu"
          :default-active="activeIndex" 
          mode="horizontal" 
          :ellipsis="false" 
          @select="handleSelect"
        >
          <el-menu-item index="home">网站首页</el-menu-item>
          <el-sub-menu index="关于国投">
            <template #title>关于国投</template>
            <el-menu-item index="ccQyjj">企业简介</el-menu-item>
            <el-menu-item index="ccZzjg">组织架构</el-menu-item>
            <el-menu-item index="ccQywh">企业文化</el-menu-item>
            <el-menu-item index="ccYgfc">企业风采</el-menu-item>
            <el-menu-item index="ccXsdw">下属单位</el-menu-item>
            <el-menu-item index="ccQyyw">企业要闻</el-menu-item>
          </el-sub-menu>
          <el-sub-menu index="新闻公告">
            <template #title>新闻公告</template>
            <el-menu-item index="ccCcjb">国投简报</el-menu-item>
            <el-menu-item index="ccMtbd">媒体报道</el-menu-item>
            <el-menu-item index="ccGzdt">工作动态</el-menu-item>
            <el-menu-item index="ccXmdt">项目动态</el-menu-item>
            <el-menu-item index="ccGsggCv">公司公告</el-menu-item>
          </el-sub-menu>
          <el-sub-menu index="交流合作">
            <template #title>交流合作</template>
            <el-menu-item index="ccHzxm">合作项目</el-menu-item>
            <el-menu-item index="ccHzgs">合作公司</el-menu-item>
            <el-menu-item index="ccGsxm">公司项目</el-menu-item>
          </el-sub-menu>
          <el-sub-menu index="招采中心">
            <template #title>招采中心</template>
            <el-menu-item index="ccZbgg">招标公告</el-menu-item>
            <el-menu-item index="ccZbgs">中标公告</el-menu-item>
            <el-menu-item index="ccGyszc">供应商注册</el-menu-item>
            <el-menu-item index="ccGyszccx">供应商查询</el-menu-item>
            <el-menu-item @click="gysLogin()">供应商登录</el-menu-item>
          </el-sub-menu>
          <el-sub-menu index="党群工作">
            <template #title>党群工作</template>
            <el-menu-item index="ccLzjs">廉政建设</el-menu-item>
            <el-menu-item index="ccTdhd">团队活动</el-menu-item>
          </el-sub-menu>
          <el-menu-item index="ccZcfg">政策法规</el-menu-item>
          <el-menu-item index="lxwm">联系我们</el-menu-item>
        </el-menu>
        
        <!-- 移动端折叠菜单 -->
        <el-collapse-transition>
          <el-menu
            v-show="showMobileMenu"
            class="mobile-menu"
            :default-active="activeIndex"
            @select="handleMobileSelect"
          >
            <!-- 移动端菜单项 -->
            <el-menu-item index="home">网站首页</el-menu-item>
            <el-sub-menu index="关于国投">
              <template #title>关于国投</template>
              <el-menu-item index="ccQyjj">企业简介</el-menu-item>
              <el-menu-item index="ccZzjg">组织架构</el-menu-item>
              <el-menu-item index="ccQywh">企业文化</el-menu-item>
              <el-menu-item index="ccYgfc">企业风采</el-menu-item>
              <el-menu-item index="ccXsdw">下属单位</el-menu-item>
              <el-menu-item index="ccQyyw">企业要闻</el-menu-item>
            </el-sub-menu>
            <el-sub-menu index="新闻公告">
              <template #title>新闻公告</template>
              <el-menu-item index="ccCcjb">国投简报</el-menu-item>
              <el-menu-item index="ccMtbd">媒体报道</el-menu-item>
              <el-menu-item index="ccGzdt">工作动态</el-menu-item>
              <el-menu-item index="ccXmdt">项目动态</el-menu-item>
              <el-menu-item index="ccGsggCv">公司公告</el-menu-item>
            </el-sub-menu>
            <el-sub-menu index="交流合作">
              <template #title>交流合作</template>
              <el-menu-item index="ccHzxm">合作项目</el-menu-item>
              <el-menu-item index="ccHzgs">合作公司</el-menu-item>
              <el-menu-item index="ccGsxm">公司项目</el-menu-item>
            </el-sub-menu>
            <el-sub-menu index="招采中心">
              <template #title>招采中心</template>
              <el-menu-item index="ccZbgg">招标公告</el-menu-item>
              <el-menu-item index="ccZbgs">中标公告</el-menu-item>
              <el-menu-item index="ccGyszc">供应商注册</el-menu-item>
              <el-menu-item index="ccGyszccx">供应商查询</el-menu-item>
              <el-menu-item @click="gysLogin()">供应商登录</el-menu-item>
            </el-sub-menu>
            <el-sub-menu index="党群工作">
              <template #title>党群工作</template>
              <el-menu-item index="ccLzjs">廉政建设</el-menu-item>
              <el-menu-item index="ccTdhd">团队活动</el-menu-item>
            </el-sub-menu>
            <el-menu-item index="ccZcfg">政策法规</el-menu-item>
            <el-menu-item index="lxwm">联系我们</el-menu-item>
          </el-menu>
        </el-collapse-transition>
      </div>
    </el-col>
  </el-row>
</template>

<script setup>
import { ref, onBeforeMount, onUnmounted } from "vue";
import { Menu } from '@element-plus/icons-vue';
import http from "@/utils/api";
import config from "@/utils/config";
import { useRouter } from "vue-router";
import { useStore } from 'vuex'

const store = useStore()
const router = useRouter();
const showMobileMenu = ref(false);
let activeIndex = ref("mian");
let companyNub = ref(1);
let isFixed = ref("");
let menuRef = ref("");

const handleSelect = (row, colmm, ss, aa) => {
  if (colmm.length > 1) {
    sessionStorage.setItem("routerText", colmm[0]);
  } else {
    sessionStorage.setItem("routerText", "");
  }
  router.push({
    path: row,
  });
};

// 登录选择方法
const seletLogin = async () => {
  await config.init();
  
  try {
    let res = await http.base.LoginSelect({
      unit: "cc",
    });
    
    if (res && res.code == 0) {
      sessionStorage.setItem("token", res.data[0].token);
      sessionStorage.setItem("userInfo", JSON.stringify(res.data[0]));
      store.dispatch('updateLoginState', true); // 更新仓库登录状态为true
      companyNub.value += 1;
    } else {
      store.dispatch('updateLoginState', false); // 更新仓库登录状态为false
      // 3秒后重试
      setTimeout(seletLogin, 3000);
    }
  } catch (error) {
    store.dispatch('updateLoginState', false);
    // 3秒后重试
    setTimeout(seletLogin, 3000);
  }
};

// 生命周期钩子
onBeforeMount(() => {
  window.addEventListener("scroll", handleScroll);
  seletLogin();
});

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});

const handleScroll = () => {
  const scrollTops = window.scrollY || document.documentElement.scrollTop;
  if (scrollTops > 110) {
    isFixed.value = 1;
  } else {
    isFixed.value = 2;
  }
  return;
};

const handleMobileSelect = (index) => {
  handleSelect(index, [index]);
};

const toggleMobileMenu = () => {
  showMobileMenu.value = !showMobileMenu.value;
};

//供应商登录-跳转
const gysLogin = () => {
  window.open("http://203.56.198.34:8888", "_blank");
};
</script>

<style scoped lang="scss">
@import "@/assets/home.scss";

.header-container {
  width: 100%;
}

.headBox {
  height: 110px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 100;
  
  .headBox_title {
    text-shadow: #c0c0c0 2px 2px 2px;
    font-size: 36px;
    margin-bottom: 10px;
    color: #067605;
    text-align: center;
    line-height: 90px;
    height: 90px;
    background: url(../assets/images/home/log.jpg) no-repeat no-repeat;
    background-size: 100% 100%;
  }
}

.menu-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #f2f2f2;
  position: relative;
}

.mobile-menu-btn {
  display: none;
  padding: 10px;
  cursor: pointer;
  justify-content: flex-end;
  
  .el-icon {
    color: #067605;
  }
}

.desktop-menu {
  width: 100%;
  margin: 0 auto;
  background-color: #f2f2f2;
  border-bottom: none;
  overflow-x: auto;
  display: flex;
  justify-content: center;
}

.mobile-menu {
  width: 100%;
  background-color: #f2f2f2;
  border-bottom: none;
  display: none;
}

/* 统一修改菜单项样式 */
::v-deep .el-menu-item,
::v-deep .el-sub-menu__title {
  height: 50px;
  line-height: 50px;
  color: #333;
  transition: all 0.3s ease;
  
  &:hover {
    color: #067605 !important;
    background-color: #e6f7e6 !important;
  }
}

::v-deep .el-menu-item.is-active {
  color: #067605 !important;
  border-bottom: 2px solid #067605 !important;
  background-color: #e6f7e6 !important;
}

::v-deep .el-sub-menu.is-active .el-sub-menu__title {
  color: #067605 !important;
  border-bottom: 2px solid #067605 !important;
}

::v-deep .el-sub-menu .el-menu-item {
  &:hover {
    color: #067605 !important;
    background-color: #e6f7e6 !important;
  }
  
  &.is-active {
    color: #067605 !important;
    background-color: #e6f7e6 !important;
  }
}

/* 移动端样式 */
@media screen and (max-width: 768px) {
  .headBox {
    width: calc(100% - 2.6rem);
    height: 44px;
    background-color: #f2f2f2;
    margin-left: 2.6rem;
  }
  .headBox_title {
    font-size: 12px!important;
    line-height: 44px!important;
    height: 44px!important;
    background: none !important;
    margin-bottom: 0px !important;
  }

  .menu-box {
    border-top: 0px!important;
  }
  
  .mobile-menu-btn {
    display: flex;
    width: 2.6rem;
    margin-top: -44px;
    background-color: #f2f2f2;
  }
  
  .desktop-menu {
    display: none;
  }
  
  .mobile-menu {
    display: block;
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 99;
    background-color: #e6e6e6 !important;
    width: 100% !important;
    
    /* 确保所有一级菜单项都有背景色 */
    ::v-deep .el-menu-item,
    ::v-deep .el-sub-menu__title {
      height: 40px !important;
      line-height: 40px !important;
      background-color: #e6e6e6 !important;
      width: 100% !important;
      margin: 0 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: flex-start !important;
      font-size: 14px;
      color: #333;
      padding: 0 20px;
      box-sizing: border-box;
    }
    
    /* 子菜单展开时的样式 */
    ::v-deep .el-sub-menu {
      &.is-opened {
        > .el-sub-menu__title {
          background-color: #d9d9d9 !important;
        }
        
        .el-menu {
          background-color: #d9d9d9 !important;
          
          .el-menu-item {
            background-color: #d9d9d9 !important;
            padding-left: 30px !important;
          }
        }
      }
      
      /* 子菜单未展开时的样式 */
      &:not(.is-opened) {
        > .el-sub-menu__title {
          background-color: #e6e6e6 !important;
        }
      }
    }
    
    /* 菜单项悬停和激活状态 */
    ::v-deep .el-menu-item:hover,
    ::v-deep .el-sub-menu__title:hover {
      background-color: #d9d9d9 !important;
    }
    
    ::v-deep .el-menu-item.is-active,
    ::v-deep .el-sub-menu.is-active .el-sub-menu__title {
      background-color: #d9d9d9 !important;
    }

    ::v-deep .el-sub-menu__icon-arrow {
      right: -50px;
    }
  }
}

/* 更小的屏幕 */
@media screen and (max-width: 480px) {
  .headBox_title {
    font-size: 20px;
    line-height: 50px;
    height: 50px;
  }
  
  /* 调整移动端菜单项高度 */
  ::v-deep .mobile-menu {
    .el-menu-item,
    .el-sub-menu__title {
      height: 36px !important;
      line-height: 36px !important;
    }
  }
}
</style>